import { observer } from 'mobx-react';
import React from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import { getAppContext } from '~/lib/AppContext';
import NotificationStore, { NoticeInstance } from '~/lib/store/NotificationStore';
import './NotificationCenter.scss';

@observer
export default class NotificationCenter extends React.Component {
    store = new NotificationStore();
    notifierDisposer?: () => unknown = undefined;

    componentDidMount() {
        this.notifierDisposer = getAppContext().notify.on((notification) => {
            this.store.addNotice(
                {
                    iconColor: notification.color,
                    body: notification.body,
                    title: notification.title,
                },
                notification.timeout
            );
        });
    }

    componentWillUnmount() {
        this.notifierDisposer?.();
    }

    renderNotice(t: NoticeInstance) {
        const removeToast = () => this.store.removeNotification(t);
        return (
            <Toast key={t.id}>
                <ToastHeader icon={t.iconColor} toggle={removeToast}>
                    {t.title}
                </ToastHeader>
                <ToastBody>{t.body}</ToastBody>
            </Toast>
        );
    }

    render() {
        const notices = this.store.notices;
        return (
            <div className="notificationCenter" role="status" aria-live="polite">
                {notices.map((t) => this.renderNotice(t))}
            </div>
        );
    }
}
